let timer = function () {
    this.sleep = function (t) {
        return new Promise(function (resolve) {
            setTimeout(() => resolve('done'), t * 1000)
        })
    }
}
export default timer